export enum StatusInvoice {
    PENDING = 'PENDING',
    PAID = 'PAID',
    CANCELED = 'CANCELED',
}